import React from 'react'
import Search from './Search'

const Banner = () => {
    return (
        <div className='p-16 flex flex-col justify-evenly gap-20'>

            <div className='font-semibold text-4xl text-center'>
                Connecting High-Performing Individuals<br />
                with High-Performing Teams<br />
                for High-Performing Companies.
            </div>

            <Search />

        </div>
    )
}

export default Banner